import { z } from "zod";
import { SubsSchema } from "../paywall-js";
import { PublicWebProductSchema } from "../web";
/**
 * Messages consumed by "web-paywall-js"
 */ const WebPaywallJSSetSubstitutions = z.object({
    name: z.literal("set-substitutions"),
    substitutions: SubsSchema
});
const WebPaywallJSSetVariables = z.object({
    name: z.literal("set-variables"),
    variables: z.object({}).passthrough()
});
const WebPaywallJSSetEditing = z.object({
    name: z.literal("set-editing"),
    editing: z.boolean()
});
const WebPaywallJSSetWebProducts = z.object({
    name: z.literal("set-web-products"),
    webProducts: z.array(PublicWebProductSchema)
});
const WebPaywallJSSetValuePrefix = z.object({
    name: z.literal("set-value-prefix"),
    prefix: z.union([
        z.string(),
        z.null()
    ])
});
const WebPaywallJSPurchaseDidInitiate = z.object({
    name: z.literal("purchase-did-initiate")
});
const WebPaywallJSPurchaseDidComplete = z.object({
    name: z.literal("purchase-did-complete")
});
export const WebPaywallJSMessageSchema = z.discriminatedUnion("name", [
    WebPaywallJSSetSubstitutions,
    WebPaywallJSSetVariables,
    WebPaywallJSSetEditing,
    WebPaywallJSSetWebProducts,
    WebPaywallJSSetValuePrefix,
    WebPaywallJSPurchaseDidInitiate,
    WebPaywallJSPurchaseDidComplete
]);
export const WrappedWebPaywallJSMessageSchema = z.object({
    _type: z.literal("sw-web-paywall-js"),
    version: z.literal(1),
    events: z.array(WebPaywallJSMessageSchema)
});
